<template>
    <u-header-fixed class="header--lnb-all">
        <u-header-body-basic class="d-none d-xl-block">
            <template #left>
                <logo-primary>판심 법무법인 - 변변변성범죄센터</logo-primary>
            </template>
            <template #right>
                <u-gnb-filled class="text-center" gnbName="gnb" lnbTag="u-lnb-all-opacity-black" />
            </template>
        </u-header-body-basic>
    </u-header-fixed>
</template>

<script>
import LogoPrimary from "@/components/publish/parents/headers/logo-primary.vue";
import UserItemsPrimary from "@/components/publish/parents/headers/user-items-primary.vue";
import LanguageItemsPrimary from "@/components/publish/parents/headers/language-items-primary.vue";
import BtnHamburgerPrimary from "@/components/publish/parents/buttons/btn-hamburger-primary.vue";
import SitemapPrimary from "@/sets/parents/headers/sitemap-primary.vue";

import UHeaderBasic from "@/sets/styles/headers/u-header-basic.vue";
import UHeaderFixed from "@/sets/styles/headers/u-header-fixed.vue";
import UHeaderHeadBasic from "@/sets/styles/headers/u-header-head-basic.vue";
import UHeaderBodyBasic from "@/sets/styles/headers/u-header-body-basic.vue";
import UHeaderFootBasic from "@/sets/styles/headers/u-header-foot-basic.vue";

import Gnb from "@/components/publish/styles/headers/gnb.vue";
import UGnbBasic from "@/components/publish/styles/headers/u-gnb-basic.vue";
import UGnbFilled from "@/components/publish/styles/headers/u-gnb-filled.vue";
import UGnbTopline from "@/components/publish/styles/headers/u-gnb-topline.vue";
import UGnbUnderline from "@/components/publish/styles/headers/u-gnb-underline.vue";

export default {
    components: {
        LogoPrimary,
        UserItemsPrimary,
        LanguageItemsPrimary,
        BtnHamburgerPrimary,
        SitemapPrimary,

        UHeaderBasic,
        UHeaderFixed,
        UHeaderHeadBasic,
        UHeaderBodyBasic,
        UHeaderFootBasic,

        Gnb,
        UGnbBasic,
        UGnbFilled,
        UGnbTopline,
        UGnbUnderline,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {
        logout() {
            if (confirm("로그아웃 하시겠습니까?")) {
                this.$store.dispatch("logout");
            }
        },
    },
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
    },
};
</script>
